import { Link } from 'components/lib';
import { Box, Typography, styled } from '@mui/material';
import React, { ReactElement } from 'react';

export interface SubMenuItemProps {
  label: string;
  href: string;
  onClick?: () => void;
  active?: boolean;
}

/** Figma Sidebar/Sub Nav Item — 8429:4170 / Chrome/Sidebar 8429:5205 */
export const SubMenuItem = styled(
  ({
    label,
    href,
    onClick,
    active = false,
  }: SubMenuItemProps): ReactElement => {
    return (
      <Link
        href={href}
        onClick={onClick}
        sx={{
          '&&': {
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            whiteSpace: 'nowrap',
            textDecoration: 'none',
            borderRadius: 0,
            pl: '47px',
            pr: '16px',
            py: '8px',
            background: active ? '#EEF0F6' : 'transparent',
            '&:hover': {
              background: '#EEF0F6',
            },
          },
        }}
      >
        <Box display="flex" alignItems="center" width="100%">
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: '14px',
              lineHeight: '22px',
              fontWeight: active ? 500 : 400,
              color: active ? '#242D56' : '#5F6375',
            }}
          >
            {label}
          </Typography>
        </Box>
      </Link>
    );
  },
)``;
